import { Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import RoutesConfig from './RoutesConfig';
import { getBrand } from '../Utils/brand';

function AppRoutes(){

  const brand = getBrand();
  const redirectMap = brand.redirectMap || {};

  return (
  <Suspense fallback={<div></div>}>
    <Routes>
      {
        RoutesConfig.map((route, index) => {
          const Element = route.element;
          const path = route.path;
          const redirectPath = redirectMap[path];
          return <Route key={`route-${path}`} path={route.path} element={redirectPath ? <Navigate replace to={redirectPath} /> : <Element />}/>
        })
      }
    </Routes>
  </Suspense>
  );
}

export default AppRoutes;